import { render } from "./page7.vue?vue&type=template&id=40c871b8&scoped=true"
import script from "./page7.vue?vue&type=script&lang=js"
export * from "./page7.vue?vue&type=script&lang=js"

import "./page7.vue?vue&type=style&index=0&id=40c871b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c871b8"]])

export default __exports__